/**
 * 竞品分析卡片组件
 */

import React from 'react';
import { Card, Form, Row, Col, Input, InputNumber, Space, Button } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';

const { TextArea } = Input;

interface CompetitorAnalysisCardProps {
    competitors: string[];
    onAdd: () => void;
    onRemove: (index: number) => void;
    onUpdate: (index: number, value: string) => void;
}

export const CompetitorAnalysisCard: React.FC<CompetitorAnalysisCardProps> = ({
    competitors,
    onAdd,
    onRemove,
    onUpdate,
}) => {
    return (
        <Card title="🎯 竞品分析" bordered={false}>
            <Form.Item label="主要竞品">
                <Space direction="vertical" style={{ width: '100%' }}>
                    {competitors.map((competitor, index) => (
                        <Space key={index} style={{ width: '100%' }}>
                            <Input
                                value={competitor}
                                onChange={(e) => onUpdate(index, e.target.value)}
                                placeholder="输入竞品名称或ASIN"
                                style={{ width: 400 }}
                            />
                            {competitors.length > 1 && (
                                <Button
                                    danger
                                    icon={<DeleteOutlined />}
                                    onClick={() => onRemove(index)}
                                />
                            )}
                        </Space>
                    ))}
                    <Button
                        type="dashed"
                        icon={<PlusOutlined />}
                        onClick={onAdd}
                    >
                        添加竞品
                    </Button>
                </Space>
            </Form.Item>

            <Row gutter={24}>
                <Col span={12}>
                    <Form.Item
                        name={['research_data', 'price_range_low']}
                        label="竞品价格区间（低）"
                    >
                        <InputNumber
                            prefix="$"
                            min={0}
                            step={0.01}
                            style={{ width: '100%' }}
                            placeholder="最低价格"
                        />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        name={['research_data', 'price_range_high']}
                        label="竞品价格区间（高）"
                    >
                        <InputNumber
                            prefix="$"
                            min={0}
                            step={0.01}
                            style={{ width: '100%' }}
                            placeholder="最高价格"
                        />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item
                        name={['research_data', 'competitive_advantage']}
                        label="差异化优势"
                    >
                        <TextArea
                            rows={3}
                            placeholder="相比竞品，我们的产品有哪些差异化优势？"
                        />
                    </Form.Item>
                </Col>
            </Row>
        </Card>
    );
};

export default CompetitorAnalysisCard;
